import { useQuery, UseQueryResult } from "react-query";

import { ApiRoutes } from "../../constants/ApiRoutes";
import { httpClient } from "../../api-legacy/BaseApi";
import { createUrl } from "../../utils/UrlUtils";
import { MemberSpecialtyProps } from "../../dto/MemberDTO";

interface Query {
  isActiveSubSpecialities: boolean;
}

export function useMemberSpecialtiesListQuery(
  query: Query,
): UseQueryResult<MemberSpecialtyProps[], Error> {
  return useQuery(["member", "speciality", "choose"], () =>
    httpClient
      .get(createUrl(ApiRoutes.memberSpecialtyList, { query }))
      .then(({ data }) => data.data),
  );
}
